import { FC } from 'react';
import { faClockLight, faExclamationCircle } from '~/assets';
import { If } from '~/components';
import { CREDIT_SIMULATION_METHOD } from '~/utils';
import {
  ButtonComponent,
  Description,
  ModalIcon,
  Title,
  Wrapper,
} from './styles';

interface ModalCreditSimulationMethodProps {
  isOpen: boolean;
  creditSimulationMethod: CREDIT_SIMULATION_METHOD;
  handleNext: () => void;
  isLoading?: boolean;
}

const ModalCreditSimulationMethod: FC<ModalCreditSimulationMethodProps> = ({
  isOpen,
  creditSimulationMethod,
  handleNext,
  isLoading = false,
}) => {
  return (
    <Wrapper isOpen={isOpen} closeOnOverlayClick>
      <If condition={creditSimulationMethod === CREDIT_SIMULATION_METHOD.STORE}>
        <ModalIcon icon={faClockLight} />
        <Title>Atenção para os horários</Title>
        <Description>
          Para realizar o saque, dirija-se a uma farmácia São João durante o
          horário comercial. O saque está sujeito à disponibilidade de recursos
          no caixa.
        </Description>
      </If>
      <If condition={creditSimulationMethod !== CREDIT_SIMULATION_METHOD.STORE}>
        <ModalIcon icon={faExclamationCircle} />
        <Title>Atenção</Title>
        <Description>
          A chave PIX ou os dados bancários precisam ser de sua titularidade.
        </Description>
        <Description>
          A transferência será realizada após a confirmação do crédito, em dias
          úteis em horário comercial.
        </Description>
      </If>
      <ButtonComponent
        id="btn_ok"
        onPress={handleNext}
        fullWidth
        onLoading={isLoading}
      >
        CONTINUAR
      </ButtonComponent>
    </Wrapper>
  );
};

export default ModalCreditSimulationMethod;
